import { render, staticRenderFns } from "./HeaderSteps.vue?vue&type=template&id=2cf7ac66&scoped=true&"
import script from "./HeaderSteps.vue?vue&type=script&lang=js&"
export * from "./HeaderSteps.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSteps.vue?vue&type=style&index=0&id=2cf7ac66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf7ac66",
  null
  
)

export default component.exports